module.exports = __webpack_public_path__ + "static/media/ic-1.fa76f882.svg";